import(/* webpackMode: "eager", webpackExports: ["CookieBanner"] */ "/workspace/dotheforgejo/oxpa-pro/packages/shared/src/components/cookie-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LddGlobalCatcher"] */ "/workspace/dotheforgejo/oxpa-pro/packages/shared/src/components/ldd-global-catcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorHandlerProvider"] */ "/workspace/dotheforgejo/oxpa-pro/packages/shared/src/providers/error-handler-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NativePluginsProvider"] */ "/workspace/dotheforgejo/oxpa-pro/packages/shared/src/providers/native-plugins-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupabaseProvider"] */ "/workspace/dotheforgejo/oxpa-pro/packages/shared/src/providers/supabase-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/workspace/dotheforgejo/oxpa-pro/packages/shared/src/providers/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MetrikaConsent"] */ "/workspace/dotheforgejo/oxpa-pro/src/app/_components/metrika-consent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["YandexMetrikaGoals"] */ "/workspace/dotheforgejo/oxpa-pro/src/app/_components/yandex-metrika-goals.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/dotheforgejo/oxpa-pro/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ChatwootWidget"] */ "/workspace/dotheforgejo/oxpa-pro/src/components/chatwoot/ChatwootWidget.tsx");
